import { ellipsesIconFragment } from './ellipsisIconFragment';
import { graphql } from './graphql';
import { weblinkFragment } from './weblinkFragment';

export const paginationFragment = graphql(
  `
    fragment Pagination on SearchPagePagination {
      summaryMessage
      prev {
        ...WebLink
      }
      next {
        ...WebLink
      }
      pageNumberLinksAndEllipses {
        ... on EllipsisIcon {
          ...EllipsisIcon
        }
        ... on WebLink {
          ...WebLink
        }
      }
    }
  `,
  [weblinkFragment, ellipsesIconFragment],
);
